module.exports = __webpack_public_path__ + "fonts/fb7e3a2.ttf";